/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Switch, Redirect, NavLink } from 'react-router-dom';

import moment from 'moment';

import { MdRadio, MdTv, MdRefresh } from 'react-icons/md';

import Spinner from '../Spinner';

import Store from './model/ChannelStore';

import TableLimit from '../core/TableLimit';
import TableFilter from '../core/TableFilter';
import TableSummary from '../core/TableSummary';
import TablePagination from '../core/TablePagination';

import TimelineTable from './TimelineTable';
import { Calendar } from './Calendar';

const TypeToIcon = (type) => {
    switch (type) {
        case 'radio':
            return <MdRadio />;
        case 'tv':
            return <MdTv />;
        default:
            return type;
    }
};

@inject('auth')
@observer
class ChannelDetails extends Component {
    @observable store = Store.fromJS(this.props.auth, []);

    componentDidMount = () => {
        const { match } = this.props;
        this.store.page = match.params.page ? match.params.page - 1 : 0;
        this.store.type = match.params.type;
        this.fetchData(match.params.id);
        // TODO sync asset updates
        // this.assetsStore.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        const { match } = this.props;
        if (nextProps.match.params.id !== match.params.id) {
            // Id changes
            this.fetchData(nextProps.match.params.id);
        }
        if (nextProps.match.params.page !== match.params.page) {
            this.store.page = nextProps.match.params.page ? nextProps.match.params.page - 1 : 0;
            this.fetchData(nextProps.match.params.id);
        }
    };

    componentWillUnmount = () => {
        // this.assetsStore.unsyncUpdates();
    };

    fetchData = (id) => {
        this.store.fetchChannel(id);
        this.store.fetchTimelines(id);
    };

    reload = () => {
        const { match } = this.props;
        this.store.fetchTimelines(match.params.id);
    };

    render() {
        const { channel, timelines, timelinesPlayout, timelinesSchedule } = this.store;
        const { match } = this.props;

        // Do not remove. Need to use timelines Data inside Component to force render on mobx
        console.log('Timeline Summray', timelinesPlayout.length, timelinesSchedule.length);

        if (!channel || !channel.id) {
            return <span>Loading...</span>;
        }

        const startDate = moment('2019-08-01');
        const endDate = startDate.clone().endOf('month');

        const dates = [];
        while (startDate.isSameOrBefore(endDate)) {
            dates.push(startDate.clone());
            startDate.add(1, 'day');
        }

        return (
            <section>
                <h1>
                    {TypeToIcon(channel.type)} {channel.name}
                </h1>

                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table-sm table-striped">
                                <tbody>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Id"
                                                defaultMessage="Id"
                                            />
                                        </th>
                                        <td>
                                            <code>{channel.id}</code>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Type"
                                                defaultMessage="Type"
                                            />
                                        </th>
                                        <td>{channel.type}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Name"
                                                defaultMessage="Name"
                                            />
                                        </th>
                                        <td>{channel.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        {console.log(match.url)}
                        <NavLink
                            className="nav-link"
                            to={`/channels/details/${channel.id}/calendar/`}
                        >
                            Calendar
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            to={`/channels/details/${channel.id}/timelines/`}
                        >
                            Timelines
                        </NavLink>
                    </li>
                </ul>
                <div className="row">
                    <div className="mx-auto">
                        <TablePagination store={this.store} />
                    </div>
                    <div className="form-inline">
                        {/* <TableFilter store={this.store} /> */}
                        <TableLimit store={this.store} />
                        <div
                            className="btn btn-secondary"
                            onClick={this.reload}
                            onKeyDown={this.myAction}
                        >
                            <MdRefresh />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {this.store.fetchingTimelines ? (
                            <Spinner />
                        ) : (
                            <TimelineTable timelines={timelines} />
                        )}
                        <TableSummary store={this.store} />
                    </div>
                </div>
            </section>
        );
    }
}

ChannelDetails.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(ChannelDetails);
